export default __webpack_public_path__ + "static/media/calendar.bba215ee.svg";